export default "__VITE_ASSET__BOLsTIue__"